import api from './apiService';

const unwrap = (response) => response?.data?.data ?? response?.data;

export default {
  async list(params = {}) {
    const response = await api.get('/api/product-presentations', params);
    return unwrap(response) || [];
  },

  async get(id) {
    const response = await api.get(`/api/product-presentations/${id}`);
    return unwrap(response);
  },

  async create(payload) {
    const response = await api.post('/api/product-presentations', payload);
    return unwrap(response);
  },

  async update(id, payload) {
    const response = await api.put(`/api/product-presentations/${id}`, payload);
    return unwrap(response);
  },

  async activate(id) {
    const response = await api.put(`/api/product-presentations/${id}/activate`, {});
    return unwrap(response);
  },

  async deactivate(id) {
    const response = await api.delete(`/api/product-presentations/${id}`);
    return unwrap(response);
  }
};
